import {
  Add16Filled,
  DataTrendingRegular,
  RibbonRegular,
} from "@fluentui/react-icons";
import { BenefitCardOrderSubmit } from "components/BenefitCardOrderSubmit/BenefitCardOrderSubmit";
import { BenefitCategoryDialog } from "components/BenefitCategoryDialog/BenefitCategoryDialog";
import {
  ActionButton,
  StyledTab,
  StyledTabList,
  ToolbarContainer,
} from "components/styled";
import { useRoleType } from "hooks/useRoleType";
import { useAtom, useAtomValue } from "jotai";
import {
  ECountryTabView,
  IBenefitCategory,
  IClientAndBenefitCategories,
} from "library/types";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { selectedCountryTabState } from "store";
import {
  orderedBenefitCategoriesAtom,
  selectedCountryState,
} from "store/UICountryPage";
import styled from "styled-components";

type Props = {
  benefitCategories?: IClientAndBenefitCategories;
  countryBenefitCategories?: IBenefitCategory[];
  searchActive: boolean;
  searchFilterValue?: string;
};

export function CountryPageToolbar({
  benefitCategories,
  countryBenefitCategories,
  searchActive,
  searchFilterValue,
}: Props) {
  const { t } = useTranslation();

  const isReadOnlyUser = useRoleType()?.hasReadOnlyRole;

  const [addBenefitCategoryOpen, setAddBenefitCategoryOpen] = useState(false);
  const selectedCountry = useAtomValue(selectedCountryState);
  const [selectedCountryPageTab, setSelectedCountryPageTab] = useAtom(
    selectedCountryTabState
  );

  const benefitKey = `${selectedCountry?.value}-${0}-category`;

  const handleAddBenefitCategoryDialogState = useCallback((state) => {
    setAddBenefitCategoryOpen(state);
  }, []);

  const hasBenefitCategoriesToAdd =
    benefitCategories?.benefitCategories?.filter((cat) => {
      return !countryBenefitCategories?.some(
        (countryCat) =>
          countryCat.benefitCategoryParentTag === cat.benefitCategoryTag
      );
    })?.length;

  return (
    <ToolbarContainer $mobileTop="89px">
      <LeftItems>
        <StyledTabList
          onTabSelect={(e, data) => {
            setSelectedCountryPageTab(data.value as ECountryTabView);
          }}
          selectedValue={selectedCountryPageTab}
        >
          <StyledTab
            data-help="country-tab-benefits"
            icon={<RibbonRegular />}
            value={ECountryTabView.benefits}
          >
            {t("hbh.benefits.label")}
          </StyledTab>
          <StyledTab
            data-help="country-tab-analytics"
            icon={<DataTrendingRegular />}
            value={ECountryTabView.analytics}
          >
            {t("hbh.analytics.label")}
          </StyledTab>
        </StyledTabList>
      </LeftItems>

      <RightItems>
        <BenefitCardOrderSubmit
          searchFilterValue={searchFilterValue}
          disabled={searchActive}
          itemList={countryBenefitCategories || []}
          settingKey={benefitKey}
          orderedAtom={orderedBenefitCategoriesAtom}
          itemIdProperty="benefitCategoryTag"
        />

        <ActionButton
          data-help="country-add-category"
          noBorder
          disabled={
            !selectedCountry || !hasBenefitCategoriesToAdd || isReadOnlyUser
          }
          shape="circular"
          appearance="subtle"
          icon={<Add16Filled />}
          onClick={() => {
            setAddBenefitCategoryOpen(true);
          }}
        >
          {t("hbh.addBenefitCategory.label")}
        </ActionButton>
        {/* <AnalyticsButton
          appearance="transparent"
          icon={<BarChartVerticalFillIcon />}
          onClick={() => {
            setAnalyticsOpen(true);
          }}
        >
          {t("hbh.analytics.label")}
        </AnalyticsButton> */}
      </RightItems>
      {addBenefitCategoryOpen && (
        <BenefitCategoryDialog
          countryCode={Number(selectedCountry?.value) || 0}
          open={addBenefitCategoryOpen}
          setOpen={handleAddBenefitCategoryDialogState}
          benefitCategoryParentTag={Number(selectedCountry?.value)}
        />
      )}
    </ToolbarContainer>
  );
}

const LeftItems = styled.div`
  display: flex;
  align-items: center;
`;
const RightItems = styled.div`
  display: flex;
  align-items: center;
`;
